<template>
    <div class="waitModal" v-if="isShow">
        <div class="waitModalWrap">
            <h1>수강신청 서비스 <span>접속대기 중</span>입니다.</h1>
            <!-- <progress :value="currentDuration" :max="wait.totalTime"></progress> -->
            <progress :value="durationCount" :max="wait.totalCount"></progress>
            <p class="time" v-if="wait.totalTime != 0">예상 대기 시간 : <span>{{min}}분 {{sec}}초</span></p>
            <p class="time" v-else>예상 대기 시간을 계산하고있습니다</p>
            <div>
                <h3>고객님 앞에 <span>{{wait.count}}명</span>의 대기자가 있습니다.</h3>
                <p>현재 접속자가 많아 대기중이오니,<br>잠시만 기다리시면 자동 접속됩니다.</p>
            </div>
            <span class="info">※ 재 접속하실 경우 대기시간이 더 길어집니다.</span>
        </div>
    </div>
</template>
<script>
export default {
    name:"waitModal",
    props: {
        isShow: {
            type: Boolean,
            require: true,
            default: false
        },
        pWait:{
            isWaitModalShow:false,
            isJoin:false,
            count:0,
            currentCount:0,
            firstCount:0,
            totalCount:0
            // time:0
        },
        pTime:0,
        pTotalCount : 0
    },
    watch: {
        isShow: function (newVal) {
            if (newVal == true) {
                this.isShow = true;
                // this.doSearch();
            } else {
                this.isShow = false;
            }
        },
        pWait:{
            handler(newVal){
                this.wait = newVal;
                // console.log("pwait")
                // console.log(this.wait);
                this.msToTime(this.wait.totalTime);
                clearInterval(this.timeInterval);
                this.timeInterval = null;
                this.setTimer(this.wait.totalTime);
            },
            // deep:true
        },
        pTime:{
            handler(newVal){
                // console.log("ptime");
                this.time = newVal;
                
                this.totalDuration =  this.wait.totalTime - this.time
                this.msToTime(this.totalDuration)
                clearInterval(this.timeInterval);
                this.timeInterval = null;
                this.setTimer(this.totalDuration);
                // console.log(this.totalDuration);
                // this.durationCount++; 
            },
            deep:true
        },
        pTotalCount:function(newVal){
            if(newVal != this.wait.totalCount){
                // console.log(this.wait);
                // console.log("ptotalcount")
                this.durationCount++; 
            }
        }

    },
    data:()=>({
        wait:{
            isWaitModalShow:false,
            isJoin:false,
            count:0,
            totalTime:0,
            totalCount:0
        },
        time:0,

        hours:0,
        min:0,
        sec:0,

        timeInterval:null,
        currentDuration:0,
        totalDuration:0,
        changeTotalTime:0,
        durationCount:0

    }),
    mounted(){
        // console.log("waitModal");
       
    },
    methods:{
        msToTime(duration){

            // console.log("msToTime");
            // console.log(duration);
            var seconds = parseInt((duration/1000)%60)
            , minutes = parseInt((duration/(1000*60))%60)
            , hours = parseInt((duration/(1000*60*60))%24);

            hours = (hours < 10) ? "0" + hours : hours;
            minutes = (minutes < 10) ? "0" + minutes : minutes;
            seconds = (seconds < 10) ? "0" + seconds : seconds;

            this.hours = hours;
            this.min = minutes;
            this.sec = seconds;

            // console.log(this.hours)
            // console.log(this.min)
            // console.log(this.seconds)
        },
        setTimer(time){
            const me = this;
            // console.log("settimer");
            me.totalduration = time;
            this.timeInterval = setInterval(()=>{
                if(me.totalduration <= 1000){
                    clearInterval(me.timeInterval);
                    me.timeInterval = null;
                    this.wait.totalTime = 0;
                    me.totalduration = 0;
                }
                // this.currentDuration = this.currentDuration + 1000;

                me.totalduration = me.totalduration - 1000;
                // console.log(me.totalDuration);
                me.msToTime(me.totalduration);
            },1000);
        }
    }
}
</script>